import bgTexture from '@assets/images/Hero/hero-bg.png'; // or your actual background image

export default function AboutHero() {
  return (
    <section
      className="relative flex items-center justify-center bg-[#0B0B0B] text-white 2xl:py-10"
      style={{
        backgroundImage: `url(${bgTexture})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    >
      {/* === Overlay === */}
      <div className="absolute inset-0 bg-black/40"></div>

      {/* === Content === */}
      <div
        data-aos="fade-up"
        className="relative z-10 mx-auto max-w-4xl px-6 py-24 text-center md:px-12 lg:px-24 2xl:px-24"
      >
        <h1 className="text-2xl font-bold tracking-tighter sm:text-3xl md:text-4xl">
          Our Goal is to{' '}
          <span className="text-[#FFBD59]">strengthen the Philippines</span>{' '}
          through innovation in defense.
        </h1>

        <p className="mt-6 text-base leading-relaxed tracking-tighter text-gray-300 sm:text-base md:text-base">
          AeroComp is a DOST-PCIEERD–funded project that aims to develop locally
          made, high-performance ballistic protection using hybrid
          fiber-reinforced composites. Despite the Philippines’ challenges in
          establishing its own ballistic defense industry, the project aims to
          contribute to the country's materials research and development (R&D)
          for defense applications.
        </p>

        <p className="mt-4 text-sm leading-relaxed text-gray-300 sm:text-base md:text-base">
          In collaboration with the Philippine Air Force Research and
          Development Center (AFRDC), Naval Research Technology and Development
          Center (NRTDC), Philippine Navy, Philippine Army Research and
          Development Center (RDC), and ArmorSol Global Defense Inc., AeroComp
          contributes to the nation’s long-term goal of achieving
          self-sufficiency in defense capabilities.
        </p>

        <p className="mt-4 text-sm leading-relaxed text-gray-300 sm:text-base md:text-base">
          Currently, the project is now scaling up production and pushing R&D
          forward to upgrade from Level IIIA to Level III hard armor plates.
        </p>
      </div>
    </section>
  );
}
